"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddOfferAssetGalleryButton = AddOfferAssetGalleryButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const icons_1 = require("@ant-design/icons");
const antd_1 = require("antd");
const types_1 = require("@src/types");
const useConfig_1 = require("@src/hooks/useConfig");
const react_intl_1 = require("react-intl");
function AddOfferAssetGalleryButton({ addGallery }) {
    const config = (0, useConfig_1.useConfig)();
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { noStyle: true, shouldUpdate: (prevValues, currValues) => {
            var _a, _b;
            return ((_a = prevValues[types_1.EOfferAssetsFormField.galleries]) === null || _a === void 0 ? void 0 : _a.length) !==
                ((_b = currValues[types_1.EOfferAssetsFormField.galleries]) === null || _b === void 0 ? void 0 : _b.length);
        }, children: ({ getFieldValue }) => {
            const galleries = getFieldValue(types_1.EOfferAssetsFormField.galleries);
            const isReachedMaxNumberOfGalleries = galleries && galleries.length >= config.assets.offerGalleriesCountLimit;
            const buttonText = isReachedMaxNumberOfGalleries
                ? intl.formatMessage({ id: 'admin.offer.assets.max_number_of_galleries_reached' })
                : intl.formatMessage({ id: 'admin.offer.assets.add_gallery' });
            const buttonIcon = isReachedMaxNumberOfGalleries ? null : (0, jsx_runtime_1.jsx)(icons_1.PlusOutlined, { className: "m-r-s" });
            return ((0, jsx_runtime_1.jsx)(elements_1.Button, { type: "default", className: "m-t-l flex-center", onClick: addGallery, block: true, icon: buttonIcon, disabled: isReachedMaxNumberOfGalleries, children: buttonText }));
        } }));
}
